'use strict';

DoohApps
.directive('scrollButtons', ['$compile', '$timeout', function ($compile, $timeout) {
    return {
        restrict: 'A',
        scope: {
            recalculateWidth: '=',
            itemCount: '=',
            itemsContainerId: '@'
        },
        link: function (scope, elem) {
            var itemsContainer = scope.itemsContainerId !== undefined ? $(`#${scope.itemsContainerId}`) : elem;
            var leftArrow = angular.element('<div ng-hide="hide" class="scrollBtn scrollLeft"><i class="glyphicon glyphicon-menu-left"></i></div>');
            var rightArrow = angular.element('<div ng-hide="hide" class="scrollBtn scrollRight"><i class="glyphicon glyphicon-menu-right"></i></div>');
            var firstTime = true;
            scope.hide = true;

            $timeout(function () {

                function areButtonsNeeded() {
                    if (scope.itemCount < 1) {
                        scope.hide = true;
                        return;
                    }

                    var containerWidth = itemsContainer.width();
                    var elementsWidth = 0;

                    for (var i = 0; i < scope.itemCount; i++) {
                        elementsWidth += $(itemsContainer.children()[i]).outerWidth(true);
                        if (elementsWidth > containerWidth && firstTime) {
                            firstTime = false;

                            leftArrow.on('click', function (event) {
                                itemsContainer.animate({
                                    scrollLeft: '-=' + 360 + 'px'
                                });
                                detectEnd(true);
                            });
                            rightArrow.on('click', function (event) {

                                itemsContainer.animate({
                                    scrollLeft: '+=' + 360 + 'px'
                                });
                                detectEnd(false);

                            });
                            leftArrow.insertBefore(elem);
                            rightArrow.insertAfter(elem);
                            $compile(leftArrow)(scope);
                            $compile(rightArrow)(scope);
                            $('.scrollLeft').addClass('scrollBtnDisable');
                            itemsContainer.addClass('more-items-right');
                        }
                    }

                    if ((elementsWidth < containerWidth) || containerWidth == 0) scope.hide = true;
                    else scope.hide = false;                    
                }

                function detectEnd(isLeft) {
                    var newScrollLeft = itemsContainer.scrollLeft(),
                        width = itemsContainer.width(),
                        scrollWidth = itemsContainer.get(0).scrollWidth;
                    var offset = 360;
                    var res = scrollWidth - newScrollLeft - width;

                    if (!isLeft) {
                        $('.scrollLeft').removeClass('scrollBtnDisable');
                        itemsContainer.addClass('more-items-left');
                        if (res <= offset) {
                            itemsContainer.removeClass('more-items-right');
                            $('.scrollRight').addClass('scrollBtnDisable');
                        }
                    }
                    else {
                        $('.scrollRight').removeClass('scrollBtnDisable');
                        itemsContainer.addClass('more-items-right');
                        if (newScrollLeft - 360 <= 0) {
                            itemsContainer.removeClass('more-items-left');
                            $('.scrollLeft').addClass('scrollBtnDisable');

                        }
                    }
                }

                var scrollToStart = function () {
                    itemsContainer.animate({
                        scrollLeft: 0
                    });
                    detectEnd(true);
                }

                scope.$watch(function () { return scope.itemCount; }, function (newValue) {
                    areButtonsNeeded();
                });

                scope.$watch(function () { return scope.recalculateWidth; }, function (newValue, oldValue) {
                    if (newValue) {
                        areButtonsNeeded();
                        scrollToStart();
                    }
                });
            }, 0);
        }
    }
}]);